import ListItemContent from "@mui/joy/ListItemContent"

import type { NavItem } from "./navItems"

interface NavItemContentProps {
  navItem: NavItem
}

const NavItemContent = (props: NavItemContentProps) => {
  return <ListItemContent>{props.navItem.title}</ListItemContent>
}

export default NavItemContent
